export default __webpack_public_path__ + "static/media/blog.6e40dd5a.svg";